// src/components/Product/ProductCard/ProductImage.js
import React from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ProductImage = ({ 
  images, 
  currentImageIndex, 
  isHovered, 
  nextImage, 
  prevImage, 
  productName, 
  isMobile 
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: isMobile ? '160px' : '400px',
        bgcolor: '#f8f8f8',
        overflow: 'hidden'
      }}
    >
      <img
        src={images[currentImageIndex]}
        alt={productName}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.5s ease'
        }}
      />

      {/* Navigation Arrows - Hidden on mobile for better UX */}
      {images.length > 1 && isHovered && !isMobile && (
        <>
          <IconButton
            onClick={prevImage}
            sx={{
              position: 'absolute',
              left: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              bgcolor: 'rgba(255,255,255,0.9)',
              transition: 'all 0.2s ease'
            }}
          >
            <ArrowBackIosIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={nextImage}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              bgcolor: 'rgba(255,255,255,0.9)',
              transition: 'all 0.2s ease'
            }}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>
        </>
      )}

      {/* Image Dots Indicator - Smaller on mobile */}
      {images.length > 1 && (
        <Box
          sx={{
            position: 'absolute',
            bottom: isMobile ? 8 : 12,
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: 0.5,
            flexDirection: 'row-reverse'
          }}
        >
          {images.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: isMobile ? 6 : 8,
                height: isMobile ? 6 : 8,
                borderRadius: '50%',
                bgcolor: index === currentImageIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                transition: 'all 0.2s ease'
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ProductImage;
